<template>
  <div class="menu-itinerary-services">
    <div class="menu-main-action">
      <a-button v-for="menuChildItem in menuChildItems" :key="menuChildItem.type"
        :class="['menu-button', { active: type === menuChildItem.type }]" shape="round"
        @click="changeType(menuChildItem.type)">{{ menuChildItem.name }}</a-button>
    </div>
    <div  v-if="type === 'onlineCheckIn'">
      <span class="menu-tips"> 支持办理或查询与行程相关的选座、值机等服务。 </span>
      <div class="text-center">
        <img class="mt-40" :src="checkInPic" alt="check-in">
        <a-button class="w-200 mt-20" size="large" type="primary" @click="pageToCheckIn">快速值机</a-button>
      </div>
    </div>
    <div v-if="type === 'flightDynamic'">
      <a-form :form="trendFrom" layout="vertical" class="mt-20">
        <a-row>
          <a-col :span="24" class="radio-area mt-10">
            <a-radio-group name="radioGroup" v-model="trendType">
              <div>
                <a-radio :value="1">按航班号查询</a-radio>
                <a-radio :value="2">按城市名查询</a-radio>
              </div>
            </a-radio-group>
          </a-col>
          <div v-if="trendType === 1">
            <a-col :span="24" class="field-outter mt-20">
              <a-form-item label="航班号">
                <a-input v-model="flightNo" size="large" placeholder="航班号" />
              </a-form-item>
            </a-col>
            <a-col :span="24" class="field-outter">
              <a-form-item label="航班日期">
                <air-calendar v-model="goDate" :beginTime="startDateGo" :showLoading="false"
                  placeholder="航班日期"></air-calendar>
              </a-form-item>
            </a-col>
            <a-col :span="24" class="input-col mt-10">
              <a-button class="btn-search" type="primary" size="large" @click="searchDynamic" block>查 询</a-button>
            </a-col>
          </div>
          <div v-if="trendType === 2">
            <a-col :span="24" class="select-group clearfix pos-r mt-20">
              <a-col :span="19">
                <a-form-item class="control-item" label="出发地">
                  <air-flight-city-selector :data-source="citiesData" @change="onDepCityReady"
                    v-model="depCity" :visible="depCityOpen" type="single" placeholder="出发城市">
                  </air-flight-city-selector>
                </a-form-item>
              </a-col>
              <span class="exchange pos-a float-right">
                <a-icon class="icon" type="swap" @click="switchCity"> </a-icon>
              </span>
              <a-col :span="19">
                <a-form-item class="control-item" label="目的地">
                  <air-flight-city-selector :data-source="citiesData" @change="onDestCityReady"
                    @close="destCityOpen = false" v-model="destCity" :visible="destCityOpen" type="single"
                    placeholder="到达城市"></air-flight-city-selector>
                </a-form-item>
              </a-col>
            </a-col>
            <a-col :span="24"  class="field-outter">
              <a-form-item label="航班日期">
                <air-calendar v-model="goDate" :beginTime="startDateGo" :visible="depDateOpen" :showLoading="false" placeholder="航班日期"></air-calendar>
              </a-form-item>
            </a-col>
            <a-col :span="24"  class="input-col mt-10">
              <a-button class="btn-search" type="primary" size="large" @click="searchDynamic" block>查 询</a-button>
            </a-col>
          </div>
        </a-row>
      </a-form>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import checkInPic from '../../img/pic-checkin.png'
import { flightCities } from '@/assets/js/data'

export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          checkInEnable: true,
          flightStateEnable: true
        }
      }
    }
  },
  computed: {
    menuChildItems () {
      const { checkInEnable, flightStateEnable } = this.config
      const list = []

      if (checkInEnable) {
        list.push({
          type: 'onlineCheckIn',
          name: '值机'
        })
      }

      if (flightStateEnable) {
        list.push({
          type: 'flightDynamic',
          name: '航班动态'
        })
      }

      return list
    }
  },
  data () {
    return {
      type: 'onlineCheckIn',
      trendFrom: this.$form.createForm(this),
      checkInPic,
      trendType: 1, // 航班动态类型
      flightNo: '', // 航班动态-按航班号-航班号
      depCity: '', // 航班动态-按城市名-出发城市
      destCity: '', // 航班动态-按城市名-到达城市
      depCityOpen: false,
      destCityOpen: false,
      goDate: moment(), // 航班动态-航班日期
      startDateGo: moment(new Date('1990-01-01')), // TODO: 临时设置，需更新组件API
      depDateOpen: false,
      citiesData: [],
      mainSettings: window.__MICRO_ROOT__ ?? {}
    }
  },
  created () {
    this.getData()
  },
  mounted () {
    this.type = this.menuChildItems?.[0].type
  },
  methods: {
    changeType (newType) {
      const { type, menuChildItems } = this
      if (newType !== type) {
        this.type = menuChildItems.find(item => item.type !== type).type
      }
    },
    pageToCheckIn () {
      this.mainSettings.router?.push({ pathname: '/micro/main/checkin' })
    },

    async getData () {
      const cities = await flightCities()

      if (cities) {
        this.citiesData = cities
      }
    },

    switchCity () {
      ;[this.depCity, this.destCity] = [this.destCity, this.depCity]
    },
    onDepCityReady () {
      this.depCityOpen = false
      this.destCityOpen = true
    },
    onDestCityReady () {
      this.destCityOpen = false
      // this.depDateOpen = true
    },
    // 航班动态查询
    searchDynamic () {
      let param = ''
      const flightNoReg = /^[A-Za-z0-9]{6}$/
      const { goDate, flightNo, depCity, destCity } = this

      if (!goDate) {
        this.$message.error('航班日期不能为空！')
        return
      }

      if (this.trendType === 1) {
        if (!flightNo) {
          this.$message.error('航班号不能为空！')
          return
        }

        if (!flightNoReg.test(flightNo)) {
          this.$message.error('航班号输入错误！')
          return
        }

        param = {
          flightDate: moment(goDate).format('YYYY-MM-DD'),
          flightNo: flightNo
        }
      } else if (this.trendType === 2) {
        if (!depCity) {
          this.$message.error('出发地不能为空！')
          return
        }

        if (!destCity) {
          this.$message.error('目的地不能为空！')
          return
        }

        param = {
          flightDate: moment(goDate).format('YYYY-MM-DD'),
          orgCity: depCity,
          dstCity: destCity
        }
      }

      this.mainSettings.router?.push({ pathname: '/micro/main/flight/status', query: param })
    }
  }
}
</script>
